import { SET_TIMEZONES, SET_TIMEZONES_LOADED } from './actions.js';

export function timezones(state = [], action) {
	switch (action.type) {
		case SET_TIMEZONES:
			return action.data;
		default:
			return state;
	}
}

export function timezonesLoaded(state = false, action) {
	switch (action.type) {
		case SET_TIMEZONES_LOADED:
			return action.data;
		default:
			return state;
	}
}
